import { Center, HStack, IconButton, Image, VStack } from "native-base";
import React, {
  forwardRef,
  Ref,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { View } from "react-native";
import { faRepeatAlt, faTimes } from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import { translate } from "../locales/translate";
import InputBase from "../nativeBase-ui/InputBase";
import { getCaptchaCode } from "../util";
import FontAwesomeIcon from "./FontAwesomeIcon";
import Spinner from "./Spinner";
const INPUT_HEIGHT = 45;
const IMAGE_WIDTH = 100;
type Props = {
  setCaptchaId: (captchaId: string) => void;
  captchaId: string | null | undefined;
  setCaptchaCode: (captchaCode: string) => void;
  captchaCode: string | null;
  setValidCaptchaCode: any;
  errorMessage?: string | null;
  onBlur?: any;
  onKeyPress?: any;
  onSubmitEditing?: any;
};

const CaptchaCode = forwardRef((props: Props, ref: any) => {
  const {
    captchaId,
    setCaptchaId,
    setCaptchaCode,
    captchaCode,
    errorMessage,
    onBlur,
    onKeyPress,
    onSubmitEditing,
    setValidCaptchaCode,
  } = props;
  const [srcImg, setSrcImg] = useState("");
  const [refreshLoading, setRefreshLoading] = useState(false);

  useEffect(() => {
    asyncGetCaptchaCode();
  }, []);

  const asyncGetCaptchaCode = async () => {
    setTimeout(() => {
      setRefreshLoading(false);
    }, 5000);
    const captchaCode = await getCaptchaCode(captchaId);
    if (captchaCode) {
      const { captchBase64Data } = captchaCode;
      setSrcImg(captchBase64Data);
      setCaptchaId(captchaCode.captchaId);
      setValidCaptchaCode(true);
    }
    setRefreshLoading(false);
  };
  useImperativeHandle(ref, () => ({
    refreshCaptcha: () => refreshCaptchaHandler(),
  }));
  const refreshCaptchaHandler = async () => {
    setRefreshLoading(true);
    setCaptchaCode("");
    await asyncGetCaptchaCode();
  };
  if (!captchaId) {
    return <View />;
  }
  return (
    <HStack space="2" justifyContent="center" mt="2">
      <View style={{ flex: 1 }}>
        <InputBase
          containerStyle={{ marginTop: 0 }}
          inputStyle={{
            height: INPUT_HEIGHT,
            textAlign: "center",
            fontSize: 18,
            fontFamily: "Tahoma",
          }}
          showSubInput={true}
          isInvalid={errorMessage}
          errorMessage={errorMessage}
          value={captchaCode}
          onChangeText={(captchaCode: string) => {
            setCaptchaCode(captchaCode);
          }}
          placeholder={translate("login.errors.captchaCodeIsRequired")}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
          onSubmitEditing={onSubmitEditing}
        // icon={faCharCodes.faPhoneAlt}
        />
      </View>
      <Image
        src={srcImg}
        alt="captcha"
        style={{
          width: IMAGE_WIDTH,
          height: INPUT_HEIGHT,
          resizeMode: "contain",
          backgroundColor: Theme.COLORS.PRIMARY + "15",
          borderRadius: 10,
        }}
      />

      {refreshLoading ? (
        <View style={{ width: 50, height: 50 }}>
          <Spinner />
        </View>
      ) : (
        <IconButton
          colorScheme="gray"
          variant="ghost"
          style={{
            borderRadius: 10,
            backgroundColor: Theme.COLORS.PRIMARY + "15",
            shadowColor: Theme.COLORS.INPUT,
            shadowOffset: {
              width: 0,
              height: 6,
            },
            shadowOpacity: 0.3,
            shadowRadius: 6.65,
            elevation: 9,
            width: INPUT_HEIGHT,
            height: INPUT_HEIGHT,
          }}
          onPress={refreshCaptchaHandler}
          icon={
            <FontAwesomeIcon
              icon={faRepeatAlt}
              size={15}
              color={Theme.COLORS.PRIMARY}
            />
          }
        />
      )}
    </HStack>
  );
});

export default CaptchaCode;
